export default {
  'pages.importNotice.title': 'Important Notice',
  'pages.importNotice.subtitle': 'Manage and publish important notices',
  'pages.importNotice.tab.enabled': 'Enabled List',
  'pages.importNotice.tab.disabled': 'Disabled List',
  'pages.importNotice.create': 'Create Notice',
  'pages.importNotice.edit': 'Edit Notice',
  'pages.importNotice.batchDelete': 'Batch Delete',
  'pages.importNotice.confirmDelete': 'Are you sure you want to delete this notice?',
  'pages.importNotice.confirmBatchDelete': 'Are you sure you want to delete {count} selected notices?',
  'pages.importNotice.deleteSuccess': 'Notice deleted successfully',
  'pages.importNotice.batchDeleteSuccess': 'Notices deleted successfully',
  'pages.importNotice.createSuccess': 'Notice created successfully',
  'pages.importNotice.updateSuccess': 'Notice updated successfully',
  'pages.importNotice.deleteFailed': 'Failed to delete notice',
  'pages.importNotice.batchDeleteFailed': 'Failed to delete notices',
  'pages.importNotice.createFailed': 'Failed to create notice',
  'pages.importNotice.updateFailed': 'Failed to update notice',
  'pages.importNotice.getListFailed': 'Failed to get notice list',
  'pages.importNotice.columns.title': 'Title',
  'pages.importNotice.columns.content': 'Content',
  'pages.importNotice.columns.priority': 'Priority',
  'pages.importNotice.columns.status': 'Status',
  'pages.importNotice.columns.startTime': 'Start Time',
  'pages.importNotice.columns.endTime': 'End Time',
  'pages.importNotice.columns.createdBy': 'Created By',
  'pages.importNotice.columns.createTime': 'Create Time',
  'pages.importNotice.columns.operations': 'Operations',
  'pages.importNotice.actions.view': 'View',
  'pages.importNotice.actions.edit': 'Edit',
  'pages.importNotice.actions.delete': 'Delete',
  'pages.importNotice.titleRequired': 'Please enter notice title',
  'pages.importNotice.titlePlaceholder': 'Please enter notice title',
  'pages.importNotice.contentRequired': 'Please enter notice content',
  'pages.importNotice.contentPlaceholder': 'Please enter notice content',
  'pages.importNotice.statusRequired': 'Please select status',
  'pages.importNotice.startTimePlaceholder': 'Please select start time',
  'pages.importNotice.endTimePlaceholder': 'Please select end time',
  'pages.importNotice.status.enabled': 'Enabled',
  'pages.importNotice.status.disabled': 'Disabled',
  'pages.importNotice.priority.level1': 'Level 1 - Low',
  'pages.importNotice.priority.level2': 'Level 2 - Medium Low',
  'pages.importNotice.priority.level3': 'Level 3 - Medium',
  'pages.importNotice.priority.level4': 'Level 4 - Medium High',
  'pages.importNotice.priority.level5': 'Level 5 - High',
  'pages.importNotice.detail.title': 'Notice Details',
  'pages.importNotice.detail.content': 'Notice Content',
};
